import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Pattern from "../assets/images/pattern.png";
import LoginBg1 from "../assets/images/login-02.png";
import Logo from "../assets/images/new_vitalX_logo.svg";

import { login, sendOtp, verifyOtp, verifyUserOtp } from "../services/authApi";
import { isAuthenticated } from "../utils/commonUtils";
import { showToast } from "../../patient/utils/toastUtils";
import { ToastContainer } from "react-toastify";
import { validatePhoneNumber } from "../utils/validationUtils";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [showElementOtp, setElementOtp] = useState(false);

  const [attemptsRemaining, setAttemptsRemaining] = useState(3);
  const [cooldown, setCooldown] = useState(false);
  const [cooldownTime, setCooldownTime] = useState(300);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is already authenticated
    if (isAuthenticated()) {
      // Redirect to the dashboard or any other route
      navigate("/clinic/dashboard");
    }
  }, [navigate]);

  useEffect(() => {
    let timer;
    if (cooldown) {
      timer = setInterval(() => {
        setCooldownTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [cooldown]);

  useEffect(() => {
    let cooldownTimer;
    if (cooldownTime <= 0) {
      setCooldown(false);
      setCooldownTime(300);
    } else if (cooldown) {
      cooldownTimer = setTimeout(() => {
        setCooldownTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => clearTimeout(cooldownTimer);
  }, [cooldown, cooldownTime]);

  useEffect(() => {
    if (attemptsRemaining == 0) {
      setCooldown(true);
      localStorage.setItem(phoneNumber, new Date());
      setTimeout(() => setCooldown(false), 300000); // 5 minutes cooldown
      setCooldown(true);
      setErrorMessage("");
    }
  }, [attemptsRemaining]);

  useEffect(() => {
    const convertSetTimingLocal = localStorage.getItem(phoneNumber);
    if (convertSetTimingLocal) {
      const time = getTimeDifferenceInSeconds(convertSetTimingLocal);

      if (time >= 300) {
        setCooldown(false);
        setAttemptsRemaining(3);
        localStorage.removeItem(phoneNumber);
      } else {
        setCooldownTime(300 - time);
        setCooldown(true);
        setTimeout(() => setCooldown(false), 300000 - time * 1000); // 5 minutes cooldown
      }
    }
  }, [phoneNumber]);

  const handleLogin = async (event) => {
    event.preventDefault();

    // Check if email or password is empty
    if (!email.trim() || !password.trim()) {
      showToast("Please insert email and password", "error");
      return;
    }

    const { success, token, message } = await login(email, password);

    if (success) {
      localStorage.setItem("token", token);
      showToast("Success Login", "success");
      setTimeout(() => {
        navigate("/clinic/dashboard");
      }, 1000);
    } else {
      showToast(message, "error");
    }
  };

  const handleSendOtp = async () => {
    if (!validatePhoneNumber(phoneNumber)) {
      setErrorMessage("Please enter a valid 10 digit phone number");
      return;
    }
    const response = await sendOtp(phoneNumber);

    if (response?.status) {
      showToast("OTP sent", "success");
      setTimeout(() => {
        setElementOtp(true);
      }, 1000);
    } else {
      showToast(`${response?.message}`, "error");
    }
  };

  const handleVerifyOtp = async () => {
    const { success, token, role, message } = await verifyUserOtp(
      phoneNumber,
      otp
    );

    if (success) {
      localStorage.setItem("token", token);

      switch (role) {
        case "doctor":
          navigate("/clinic/dashboard");
          break;
        case "receptionist":
          navigate("/receptionview");
          break;
        default:
          throw new Error("Unknown role");
      }
    } else {
      showToast(message, "error");
      /* if (message === "Invalid OTP or OTP has expired") {
        showToast("Invalid OTP or OTP has expired. Please try again.", "error");
      } else {
        showToast("Failed to verify OTP. Please try again later.", "error");
      } */
    }
  };

  const handleResendOtp = async () => {
    setErrorMessage("");

    try {
      const response = await sendOtp(phoneNumber);

      if (response?.status) {
        // Display success message
        showToast("OTP resent successfully", "success");
        // Decrease attempts remaining
        setAttemptsRemaining(attemptsRemaining - 1);

      } else {
        // Display error message if resend failed
        setErrorMessage("Error resending OTP. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("Error resending OTP. Please try again.");
    }
  };

  const handleToggleOtpForm = () => {
    setShowOtpForm(!showOtpForm);
  };

  function getTimeDifferenceInSeconds(givenDateTimeString) {
    const givenTime = new Date(givenDateTimeString);
    const currentTime = new Date();
    const differenceInSeconds = Math.floor(
      (currentTime.getTime() - givenTime.getTime()) / 1000
    );
    return differenceInSeconds;
  }

  return (
    <div className="app-layout-blank flex flex-auto flex-col max-h-auto">
      <div className="flex w-full min-h-screen">
        <div className="bg-no-repeat bg-cover py-6 px-16 flex-col justify-between hidden lg:flex  relative overflow-hidden bg-gradient-to-t from-[#2E37A4] from-5% via-[#81bbf5] via-30% to-white to-80% w-full xl:w-5/12 drop-shadow">
          <img
            src={Pattern}
            className=" absolute  z-0 left-0 bottom-0 opacity-100 w-full h-full"
            alt=""
          />
          <img
            src={LoginBg1}
            className=" absolute  z-0 left-0 bottom-0"
            alt=""
          />
          <div className=" relative overflow-hidden">
            <img src={Logo} className=" w-4/12" alt="" />
          </div>

          <div>
            <p className="text-lg text-white opacity-80">
              Transform your clinic with digital efficiency in under 30 minutes.
            </p>
          </div>
        </div>

        <div className="flex flex-col  lg:justify-center items-center w-full  xl:w-7/12 bg-[#f5f5f6] pt-5 xl:py-3">
          <div className="xl:w-7/12 px-5">
            <div className=" bg-white  px-8 md:px-10 xl:px-14 py-12  rounded-2xl drop-shadow">
              <div className="mb-8">
                <h3 className="mb-1 text-xl font-bold">Welcome back!</h3>
                <p className="text-gray-600">
                  Please enter your credentials to sign in!
                </p>
              </div>

              {showOtpForm ? (
                <>
                  {!showElementOtp && (
                    <>
                      <div className=" inline-flex flex-col w-full relative mb-5">
                        <label
                          htmlFor="phoneNumber"
                          className="mb-2 text-gray-800 bg-white font-semibold text-[14px]"
                        >
                          Phone Number
                        </label>

                        <input
                          id="phoneNumber"
                          value={phoneNumber}
                          type="contact"
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          className=" min-h-[45px] w-full px-5 outline-none border-2 border-gray-200  rounded-md  focus:ring-blue-600 focus:border-blue-600"
                        />
                      </div>

                      <button
                        type="submit"
                        onClick={handleSendOtp}
                        className="min-w-[131px]  w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1a238f] text-white"
                      >
                        Send OTP
                      </button>
                      {/* Forgot Password */}
                      <span style={{ color: "#2E37A4" }} className="flex justify-end mt-2 cursor-pointer" onClick={()=> navigate('/clinic/forgotPassword')}>Forgot Password?</span>
                      <div className=" text-red-500">{errorMessage}</div>
                    </>
                  )}

                  {showElementOtp && (
                    <>
                      <div className=" inline-flex flex-col w-full relative mb-5">
                        <label
                          htmlFor="otp"
                          className="mb-2 text-gray-800 bg-white font-semibold text-[14px]"
                        >
                          OTP
                        </label>

                        <input
                          id="otp"
                          value={otp}
                          type="contact"
                          onChange={(e) => setOtp(e.target.value)}
                          className={`min-h-[45px] w-full px-5 outline-none border-2 bg-[#f2f9ff] md:bg-white border-gray-200 rounded-md focus:ring-[#076ec7] focus:border-[#076ec7]
                          ${cooldown ? " cursor-not-allowed" : ""}
                          `}
                          disabled={cooldown}
                        />
                      </div>

                      <button
                        type="submit"
                        onClick={handleVerifyOtp}
                        className={`min-w-[131px] w-full text-base  font-medium rounded-lg py-2 px-5 bg-[#2E37A4] text-white ${
                          cooldown
                            ? " opacity-55 cursor-not-allowed"
                            : "hover:bg-[#1a238f] "
                        }`}
                        disabled={cooldown}
                      >
                        Verify OTP
                      </button>

                      {/* Display cooldown message with timer */}
                      {cooldown && (
                        <div className=" mt-3 text-center ">
                          Maximum attempts reached. Try again after{" "}
                          <span className=" font-semibold text-xl">
                            {Math.floor(cooldownTime / 60)}:
                            {cooldownTime % 60 < 10
                              ? `0${cooldownTime % 60}`
                              : cooldownTime % 60}{" "}
                          </span>
                          minutes.
                        </div>
                      )}

                      {attemptsRemaining > 0 && !cooldown && (
                        <div className=" mt-7 flex justify-between flex-col text-center">
                          <button
                            className="  bg-white text-blue-700 !border border-blue-700 py-1.5 self-center"
                            onClick={handleResendOtp}
                          >
                            Resend OTP
                          </button>
                        </div>
                      )}

                      {/* Display attempts remaining */}
                      {attemptsRemaining > 0 && !cooldown && (
                        <div className=" text-sm text-gray-600 text-center pt-3">
                          Attempts remaining: {attemptsRemaining}
                        </div>
                      )}
                    </>
                  )}
                  {!showElementOtp && (
                    <div className="flex gap-x-2 mt-5">
                      <span className=" text-gray-500"> Back to</span>
                      <a
                        onClick={handleToggleOtpForm}
                        className=" font-semibold cursor-pointer"
                      >
                        {" "}
                        Email/Password
                      </a>{" "}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className=" inline-flex flex-col w-full relative mb-6">
                    <label
                      htmlFor="email"
                      className="mb-2 text-gray-800 bg-white font-semibold text-[14px]"
                    >
                      Email
                    </label>

                    <input
                      id="email"
                      value={email}
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      className=" min-h-[45px] w-full px-5 outline-none border-2 border-gray-200  rounded-md  focus:ring-blue-600 focus:border-blue-600"
                    />
                  </div>

                  <div className=" inline-flex flex-col w-full relative  mb-6">
                    <label
                      htmlFor="password"
                      className="mb-2 text-gray-800 bg-white font-semibold text-[14px]"
                    >
                      Password
                    </label>

                    <input
                      id="password"
                      value={password}
                      type="password"
                      onChange={(e) => setPassword(e.target.value)}
                      className=" min-h-[45px] w-full px-5 outline-none border-2 border-gray-200  rounded-md  focus:ring-blue-600 focus:border-blue-600"
                    />
                  </div>

                  <button
                    type="submit"
                    onClick={handleLogin}
                    className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1a238f] text-white"
                  >
                    Login
                  </button>
                  {/* Forgot Password */}
                  <span style={{ color: "#2E37A4" }} className="flex justify-end mt-2 cursor-pointer" onClick={()=> navigate('/clinic/forgotPassword')}>Forgot Password?</span>
                </>
              )}

              <div className=" mt-5">
                <span className=" text-gray-500 hidden">
                  {" "}
                  Don't have an account?{" "}
                  <button
                    onClick={() => navigate("/clinic/Registration")}
                    className="font-semibold "
                  >
                    {" "}
                    Register
                  </button>{" "}
                </span>
              </div>
            </div>
          </div>
          {showOtpForm ? (
            <></>
          ) : (
            <>
              {" "}
              <div className=" inline-flex gap-x-2 mt-5 text-gray-500">Or</div>
              <div className=" inline-flex gap-x-2 mt-5">
                <button
                  onClick={handleToggleOtpForm}
                  className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5 border bg-white hover:text-white border-[#2E37A4] hover:bg-[#2E37A4] text-[#1a238f]"
                >
                  {" "}
                  Login via OTP
                </button>{" "}
              </div>
            </>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
